import React from "react";
import { RCCChartComposedChart } from "react-common-components";
import IComponentComposedChart from "react-common-components/dist/components/Chart/ComposedChart/interface";
import { useTranslation } from "src/context/Translations/context";
import formatNumber from "src/utils/formatNumber";

const ComposedChart: React.FC<IComponentComposedChart> = ({ ...rest }) => {
	const { currentLanguage } = useTranslation();
	return <RCCChartComposedChart 
		{...rest}
		functionToFormat={(val?: string | number, decimalPlaces?: number) => !val ? "" : formatNumber(val, currentLanguage, decimalPlaces ?? 0)}
	/>;
};

export default ComposedChart;
